var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-search-wrapper" }, [
    _c(
      "div",
      { staticClass: "search-wrapper" },
      [
        _c("custom-search", {
          ref: "search",
          staticClass: "search",
          class: { shrink: _vm.open && _vm.isSearchAllowed },
          style: { paddingRight: "34px" },
          attrs: {
            search: _vm.search,
            placeholder: _vm.placeholder,
            isReadOnly: !_vm.isSearchAllowed,
            id: "global-search",
          },
          on: {
            "update:search": function ($event) {
              _vm.search = $event
            },
          },
          nativeOn: {
            click: function ($event) {
              return _vm.makeSearchOpened.apply(null, arguments)
            },
          },
        }),
        _c(
          "a",
          {
            staticClass: "search-close",
            class: { h: !_vm.open },
            style: _vm.calcAuxStyles,
            on: { click: _vm.close },
          },
          [_vm._v(_vm._s(_vm.$t("cancel")))]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "search-body" },
      [
        _vm.isSearchAllowed && _vm.open
          ? _c("global-search", { attrs: { search: _vm.search } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }